import type { NavigationItem } from '../types'

/**
 * Check if the item (or it's children when available) is active.
 */
export const isItemActive = (item: NavigationItem, pathname: string) => {
  if (item.children)
    return (
      item.url === pathname ||
      item.children.some(
        (childItem) => (childItem as NavigationItem).url === pathname,
      )
    )
  return item.url === pathname
}

/**
 * Finds the navigation link matching the current URL path and scrolls it into the center of the view.
 * This function should only be called on the client-side as it interacts with the DOM.
 */
export const scrollActiveNavLinkIntoView = (isMobile = false) => {
  // Check if document is defined (client-side only)
  if (typeof document !== 'undefined') {
    // Get the current pathname from the window location
    const currentPath = window.location.pathname + window.location.hash

    // Find all anchor elements within the sidenav
    const navLinks = document.querySelectorAll(
      isMobile
        ? '[aria-label="mobile navigation"] a[href]'
        : '[aria-label="desktop navigation"] a[href]',
    )

    // Look for the link that matches the current path and scroll it into view
    for (const link of navLinks) {
      const href = link.getAttribute('href')
      if (href === currentPath) {
        link.scrollIntoView({ behavior: 'auto', block: 'center' })
        break // Stop after finding the first matching link
      }
    }
  }
}
